import React from 'react';
import './CancellationPolicy.css';

const CancellationPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Order Cancellation Policy – Derby-India</h1>
      <p>
        At <strong>Derby-India</strong> (
        <a href="https://derbyindia.in/" target="_blank" rel="noopener noreferrer">
          https://derbyindia.in/
        </a>
        ), we work hard to deliver quality products on time. If you need to cancel your order, please follow our simple cancellation guidelines.
      </p>

      <h2>✅ Cancellation Before Shipment</h2>
      <ul>
        <li><strong>When Allowed:</strong> Within 2 hours of placing the order or before shipping.</li>
        <li>
          <strong>How to Cancel:</strong>
          <ul>
            <li>Login to your account</li>
            <li>Go to <strong>My Orders</strong></li>
            <li>Select and click <strong>Cancel Order</strong></li>
            <li>Or email us at <a href="mailto:contact@derbyindia.in">contact@derbyindia.in</a> or call <strong>+91 9322986301</strong></li>
          </ul>
        </li>
        <li><strong>Refund:</strong> For prepaid orders, refunds will be processed within 5–7 business days.</li>
      </ul>

      <h2>❌ Cancellation After Shipment</h2>
      <p>
        Cancellations are not allowed after the order has been shipped. You can still refuse delivery or request a return per our Return & Refund Policy.
      </p>

      <h2>⚠️ Exceptions</h2>
      <ul>
        <li>Customized or non-returnable items are not eligible for cancellation.</li>
        <li>Bulk/special orders may have separate terms.</li>
      </ul>

      <h2>📩 Contact Us</h2>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:contact@derbyindia.in">contact@derbyindia.in</a></li>
        <li><strong>Phone:</strong> +91 9322986301</li>
        <li><strong>Website:</strong> <a href="https://derbyindia.in/" target="_blank" rel="noopener noreferrer">https://derbyindia.in/</a></li>
      </ul>
    </div>
  );
};

export default CancellationPolicy;
